import { MatchingSelectionScreen } from '@app/matching/components/MatchingSelectionScreen';

export const AdminMatchingPage = () => {
  return <MatchingSelectionScreen />;
};
